import { Injectable } from '@angular/core';
import { Command, CommandService, StateService  } from 'flux-core';
import { DiagramChangeService } from '../../../base/diagram/diagram-change.svc';
import { AbstractDiagramChangeCommand } from './abstract-diagram-change-command.cmd';
import { DiagramCommandEvent } from './diagram-command-event';

@Injectable()
@Command()
export class OrgChartManageImage extends AbstractDiagramChangeCommand {
    /**
     * Command input data format
     */
    public data: {
        id: string,
        value: string,
        alterFunction?: string,
    };

    /**
     * Inject the state service to get the list of selected shape ids.
     */
    constructor(
            protected commandService: CommandService,
            protected ds: DiagramChangeService,
            protected state: StateService<any, any>,
        ) {
        super( ds );
    }

    /**
     * Invoke the alterFunction on the changeModel.
     */
    public prepareData() {
        if ( this.data.alterFunction ) {
            this.commandService.dispatch(
                DiagramCommandEvent.doShapeAction,
                this.state.get( 'CurrentDiagram' ),
                { alterFunction: this.data.alterFunction },
            );
        } else {
            const seleted = this.state.get( 'Selected' )[0];
            this.commandService.dispatch(
                DiagramCommandEvent.uploadShapeImage,
                this.state.get( 'CurrentDiagram' ),
                { position: { shapeId: seleted, imageId: '_imageURLSource' }},
            );
        }
    }
}

Object.defineProperty( OrgChartManageImage, 'name', {
    value: 'OrgChartManageImage',
});
